module.exports = __webpack_public_path__ + "img/square-phone.93cba533.svg";